import React, { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

const CountdownCell = ({ value, label }) => (
  <div className="flex flex-col items-start min-w-0">
    <span className="font-stats text-3xl sm:text-4xl md:text-6xl font-extrabold text-white leading-none tabular-nums">
      {pad(value)}
    </span>
    <span className="mt-1 text-[9px] sm:text-[10px] md:text-xs uppercase tracking-[0.25em] md:tracking-[0.3em] text-neutral-500 font-stats">
      {label}
    </span>
  </div>
);

/**
 * Live countdown to a target ISO date. Editorial broadcast style.
 */
export default function Countdown({ target, testId = "countdown" }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!target) return undefined;
    const targetTs = new Date(target).getTime();
    // R4.2 — stop the 1 Hz ticker as soon as the event has started.
    // Before this, the interval kept firing indefinitely on every visit
    // to a page featuring a past event (Home hero when no upcoming event
    // is set, past event detail page, etc.).
    if (Number.isFinite(targetTs) && targetTs - Date.now() <= 0) {
      return undefined;
    }
    const id = setInterval(() => {
      const current = new Date();
      setNow(current);
      if (Number.isFinite(targetTs) && targetTs - current.getTime() <= 0) {
        clearInterval(id);
      }
    }, 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target) return null;

  const diff = new Date(target).getTime() - now.getTime();

  if (diff <= 0) {
    return (
      <div
        data-testid={`${testId}-live`}
        className="font-stats text-sm text-burkina-red uppercase tracking-widest"
      >
        L&apos;ÉVÉNEMENT EST EN COURS
      </div>
    );
  }

  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff % 86_400_000) / 3_600_000);
  const mins = Math.floor((diff % 3_600_000) / 60_000);
  const secs = Math.floor((diff % 60_000) / 1000);

  return (
    <div
      data-testid={testId}
      className="flex flex-wrap gap-3 sm:gap-6 md:gap-10 items-end pt-2 max-w-full"
    >
      <CountdownCell value={days} label="Jours" />
      <span className="text-2xl sm:text-3xl md:text-5xl text-neutral-700 leading-none">·</span>
      <CountdownCell value={hours} label="Heures" />
      <span className="text-2xl sm:text-3xl md:text-5xl text-neutral-700 leading-none">·</span>
      <CountdownCell value={mins} label="Min" />
      <span className="text-2xl sm:text-3xl md:text-5xl text-neutral-700 leading-none">·</span>
      <CountdownCell value={secs} label="Sec" />
    </div>
  );
}
